import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Container from '../../../node_modules/reactstrap/esm/Container.js';
import Row from '../../../node_modules/reactstrap/esm/Row.js';
import Col from '../../../node_modules/reactstrap/esm/Col.js';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import is from '../../../node_modules/ramda/es/is.js';
import Theme from '../../../Theme/index.js';
import CommentCol from './CommentCol.js';
import ScoreCol from './ScoreCol.js';
import '../../Dashboard/Panel.js';
import '../../Dashboard/SectionHeader.js';
import { Button } from '../../Dashboard/Button.js';
import '../../Dashboard/Title.js';
import { closeFeedbackFormAnim } from '../animations.js';

var _templateObject, _templateObject2, _templateObject3;
var Montserrat = Theme.fonts.Montserrat;
var _Theme$colors = Theme.colors,
  primary = _Theme$colors.primary,
  blueGrey = _Theme$colors.blueGrey;
var FormWrapper = styled(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  ", "\n"])), Montserrat, blueGrey, function (props) {
  return props.hide && closeFeedbackFormAnim;
});
var Heading = styled.h5(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  padding-bottom: 1.5rem;\n"])), primary);
var ButtonHolder = styled(Col).attrs({
  xs: 12
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: right;\n  padding: 10px 0 0;\n"])));
var HeadingRow = function HeadingRow() {
  return /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Heading, null, "What do you think about the changes we\u2019ve made?")));
};
var FeedbackForm = function FeedbackForm(_ref) {
  var onFormSubmit = _ref.onFormSubmit,
    hide = _ref.hide,
    onScoreSelect = _ref.onScoreSelect,
    onCommentChange = _ref.onCommentChange,
    comment = _ref.comment,
    score = _ref.score;
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: onFormSubmit,
    id: "feedback-form-anchor"
  }, /*#__PURE__*/React__default.createElement(FormWrapper, {
    hide: hide ? 1 : undefined
  }, /*#__PURE__*/React__default.createElement(HeadingRow, null), /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(ScoreCol, {
    onScoreClick: onScoreSelect,
    score: score
  }), /*#__PURE__*/React__default.createElement(CommentCol, {
    comment: comment,
    onCommentChange: onCommentChange
  })), /*#__PURE__*/React__default.createElement(ButtonHolder, null, /*#__PURE__*/React__default.createElement(Button, {
    type: "submit",
    disabled: !is(Number, score)
  }, "Submit"))));
};
FeedbackForm.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
  onScoreSelect: PropTypes.func.isRequired,
  onCommentChange: PropTypes.func.isRequired,
  hide: PropTypes.bool,
  comment: PropTypes.string,
  score: PropTypes.number
};

export { FeedbackForm as default };
